import { useHistory, useLocation } from 'react-router-dom';

export type param = 'advertiserid' | 'draftid' | 'jobid' | 'referrer';

export const useQueryParams = () => {
  const location = useLocation();
  const history = useHistory();

  const getParams = () => {
    if (typeof window !== 'undefined') {
      return new URLSearchParams(location.search.toLowerCase());
    }
  };

  const getParam = (param: param) => {
    const params = getParams();
    return params?.get(param);
  };

  const getDraftIdParam = () => getParam('draftid');
  const getJobIdParam = () => getParam('jobid');
  const getReferrerParam = () => getParam('referrer');

  const removeParams = (params: param[]) => {
    const newParams = getParams();

    params.map((p) => {
      newParams?.delete(p);
    });

    history.replace({
      pathname: location.pathname,
      search: newParams?.toString(),
    });
  };

  const updateParam = (
    paramName: 'draftid' | 'jobid' | 'referrer',
    value: string | null,
  ) => {
    // Only update param if it existed in the URL to start with
    const currentParamValue = getParam(paramName);
    if (!currentParamValue) {
      return;
    }

    // Don't update if its the same value
    if (currentParamValue === value) {
      return;
    }

    const newParams = getParams();

    // Delete existing
    newParams?.delete(paramName);

    // Set new one if its a valid value
    if (value) {
      newParams?.set(paramName, value);
    }

    history.replace({
      search: newParams?.toString(),
    });
  };

  const setParams = (
    params: Array<{
      name: param;
      value: string | null;
    }>,
  ) => {
    const newParams = getParams();

    params.forEach((param) => {
      if (param.value === null) {
        newParams?.delete(param.name);
      }
      if (param.value) {
        newParams?.set(param.name, param.value);
      }
    });

    history.replace({
      pathname: location.pathname,
      search: newParams?.toString(),
    });
  };

  return {
    getDraftIdParam,
    getJobIdParam,
    getReferrerParam,
    removeParams,
    updateParam,
    setParams,
  };
};
